// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper__2wuez","rotate":"Loader_rotate__2CUi0"};